import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition
} from "@angular/material/snack-bar";
import { TranslateService } from "@ngx-translate/core";
import { KeycloakService } from "keycloak-angular";
import { BehaviorSubject, Observable, timer } from "rxjs";
import { map, take } from "rxjs/operators";
import moment from "moment";

import { LanguageService } from "./language.service";
import { environment } from "src/environments/environment";
import { AlertDTO } from "../../shared/models/alert-dto";

@Injectable({
  providedIn: "root"
})
export class AlertService {
  private alertUrl = "alerts/";
  private alerts$: BehaviorSubject<AlertDTO[]> = new BehaviorSubject(null);
  private unreads$: BehaviorSubject<AlertDTO[]> = new BehaviorSubject(null);
  private unreadsNumer$: BehaviorSubject<number> = new BehaviorSubject(null);

  horizontalPosition: MatSnackBarHorizontalPosition = "end";
  verticalPosition: MatSnackBarVerticalPosition = "bottom";

  constructor(
    private keycloakService: KeycloakService,
    private http: HttpClient,
    private translateService: TranslateService,
    private _snackBar: MatSnackBar,
    private languageService: LanguageService
  ) {}

  private setAlerts$ = (items: AlertDTO[]) => this.alerts$.next(items);
  public setUnreadAlerts$ = (items: AlertDTO[]) => this.unreads$.next(items);
  public setNumberUnreadAlerts$ = (items: number) =>
    this.unreadsNumer$.next(items);
  public getAlerts$ = (): Observable<AlertDTO[]> => this.alerts$.asObservable();
  public getUnreadAlerts$ = (): Observable<AlertDTO[]> =>
    this.unreads$.asObservable();
  public getNumberUnreadAlerts$ = (): Observable<number> =>
    this.unreadsNumer$.asObservable();

  public checkAlert() {
    /* Disabled until resolve the Technical Debt 6493: https://dev.azure.com/bisbmining/Smart%20Fleet/_workitems/edit/6493
    timer(0, 300000).subscribe(() => {
      this.keycloakService.isLoggedIn().then(async (loggedIn) => {
        if (loggedIn) {
          this.keycloakService.loadUserProfile().then((userProfile) => {
            this.getAlerts()
              .pipe()
              .subscribe((observableAlerts) => {
                observableAlerts.subscribe((alerts) => {
                  this.setAlerts$(alerts);
                  this.setReceived(alerts).subscribe((res) => res);
                  const sentStatus = alerts.filter(
                    (currentAlert) => currentAlert.status === "SENT"
                  );
                  const setUnreadAlerts = alerts.filter(
                    (currentAlert) => currentAlert.readStatus === "UNREAD"
                  );
                  this.setUnreadAlerts$(setUnreadAlerts);
                  this.setNumberUnreadAlerts$(setUnreadAlerts.length);
                  if (sentStatus.length > 0) {
                    this.openSnackBar(userProfile.firstName, sentStatus.length);
                  }
                });
              });
          });
        }
      });
    });*/
  }

  openSnackBar(userName: string, numberMessages: number) {
    this.translateService
      .get("alert-snackbar")
      .pipe(take(1))
      .subscribe((translate) => {
        const word = translate.split("|");
        this._snackBar.open(
          `${userName} ${word[0].replace("@", numberMessages)}`,
          word[1],
          {
            horizontalPosition: this.horizontalPosition,
            verticalPosition: this.verticalPosition,
            panelClass: ["alert-snackbar-background"]
          }
        );
      });
  }

  setRead(alertId: number) {
    return this.http.put<any>(
      `${environment.apiUrl}${this.alertUrl}${alertId}/read`,
      "READ"
    );
  }

  setReceived(messages: AlertDTO[]): Observable<AlertDTO[]> {
    return this.http.put<any>(
      `${environment.apiUrl}${this.alertUrl}receive`,
      messages
    );
  }

  private getAlerts() {
    return this.languageService.getLanguage$().pipe(
      map((currentLanguage) => {
        const headers = new HttpHeaders({
          "Content-Type": "application/json",
          "Accept-Language": currentLanguage
        });
        return this.http
          .get<AlertDTO[]>(`${environment.apiUrl}${this.alertUrl}`, { headers })
          .pipe(map((service) => service));
      })
    );
  }

  public alertTemplate(
    title: string,
    alertMessage: string,
    createdAt: string
  ): string {
    const date = moment(new Date(createdAt)).format("DD/MM/YYYY HH:mm");
    return `<p>${title}</p>
            <p>${alertMessage}</p>
            <p>${date}</p>
             <p><img src ="assets/img/email-template.png" style="width: 90%" alt = "bosch"></p>`;
  }
}
